import { render } from "./updateprepareas.vue?vue&type=template&id=cf8aa4fe"
import script from "./updateprepareas.vue?vue&type=script&lang=js"
export * from "./updateprepareas.vue?vue&type=script&lang=js"

import "./updateprepareas.vue?vue&type=style&index=0&id=cf8aa4fe&lang=css"

import exportComponent from "/home/runner/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__